import i18next, { InitOptions } from "i18next"; // *** TODO separate
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import common_fi from "../translations/fi/common";
import common_sv from "../translations/sv/common";
import common_en from "../translations/en/common";

const languages = ['fi', 'sv', 'en'];

i18next
  // detect user language
  //  - learn: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  //  - options: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "en-GB",
    detection: {
      // https://github.com/i18next/i18next-browser-languageDetector
      order: ['navigator'],
    },
    interpolation: {
      escapeValue: false // React already does escaping
    },
    // lng: 'en', // language to use
    // `whitelist` was a no-op from i18next v21 and is gone in v26, so this takes
    // dev's rename. Note `supportedLngs` genuinely restricts languages where
    // `whitelist` did nothing — and `fallbackLng` below is "en-GB", which is not
    // in this list and has no resource bundle of its own. That combination is in
    // production on dev and works (i18next resolves en-GB down to en), but it is
    // the reason to reach for 'en' if fallback behaviour ever looks wrong.
    supportedLngs: languages,
    resources: {
        fi: {
          common: common_fi, // 'common' is our custom namespace
        },
        sv: {
          common: common_sv,
        },
        en: {
            common: common_en,
        },
    },
  } as InitOptions);
//
export default i18next;
